
import { StateCreator } from 'zustand';
import { GridFilters, GridMainSlice } from '../gridTypes';
import { setFilterPropertyHandler } from '../gridUtils';

type ImmerStateCreator<T> = StateCreator<
  T,
  [["zustand/immer", never], never],
  [],
  T
>;

const initialState: GridFilters = {
    defaultGridUrl: "",
    sort: "sortOrder",
    conditionFilter: [],
    sectionFilter: [],
    sizeFilter: [],
    colorFilter: [],
    minPrice: undefined,
    maxPrice: undefined,
    gridReferenceId: undefined,
    universeId: undefined,
    customerStoreId:undefined,
    shippingTypeId:[],
    isInitialState: true,
    pageSize: undefined,
    sellerId: undefined,
    cartCode: undefined,
    categoryId: undefined,
    excludeProductId: undefined,
}


export const createMainGridSlice: ImmerStateCreator<GridMainSlice> = (set) => ({
    gridMainFilters: initialState,
    SET_MAIN_FILTER: (filterType, newValue, initialProductsClassification) => {
        set((state) => {
            const { gridMainFilters } = state
            if (initialProductsClassification) {
                state.gridMainFilters = {...gridMainFilters, ...initialProductsClassification, isInitialState: false}
            }
            else {
                const filterUpdated = setFilterPropertyHandler(gridMainFilters, filterType, newValue)
                state.gridMainFilters = {...filterUpdated, isInitialState: false}
            }
        }, false, 'SET_MAIN_FILTER')
    },
    SET_DEFAUlT_URL: (filterType, defaultUrl) => {
        set((state) => {
            state.gridMainFilters = {...state.gridMainFilters, [filterType]: defaultUrl}
        }, false, 'SET_DEFAUTL_URL')
    }, 
    RESET_MAIN_FILTER: () => {
        set((state) => {
            const currentDefaultUrl = state.gridMainFilters.defaultGridUrl;
            const resetedState = { ...initialState, defaultGridUrl: currentDefaultUrl};
            state.gridMainFilters = resetedState;
        }, false, 'RESET_MAIN_FILTER')
    },
});